import React, { useEffect } from 'react';

export default function GrafanaSignedOut() {
    useEffect(() => {
        try {
            const message = { type: 'GRAFANA_LOGGED_OUT' } as const;
            const targetOrigin = window.location.origin;
            window.parent?.postMessage(message, targetOrigin);
            window.parent?.postMessage(message, '*');
        } catch {
            // no-op
        }
    }, []);

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <p style={{ color: '#6b7280', fontSize: 14 }}>Grafana session ended.</p>
        </div>
    );
}
